import { Sqrt as SqrtScale } from '@antv/scale';
export const Sqrt = (options) => {
    return new SqrtScale(options);
};
Sqrt.props = {};
//# sourceMappingURL=sqrt.js.map